import React, { Suspense } from "react"
import { Spinner, Center } from "@chakra-ui/react"

const RichTextEditor = React.lazy(
  () => import("./RichTextEditor" /* webpackChunkName: "RichTextEditor" */)
)

const RichTextEditorLazy = (props: any) => {
  return (
    <Suspense
      fallback={
        <Center>
          <Spinner />
        </Center>
      }
    >
      <RichTextEditor {...props} />
    </Suspense>
  )
}

export default RichTextEditorLazy
